var _path, _path2, _g, _path3, _path4, _mask, _filter, _filter2, _filter3, _filter4, _filter5, _filter6, _filter7, _filter8, _filter9, _filter10, _filter11, _filter12;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCursor(_ref, svgRef) {
  var _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25;

  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1024,
    height: 1024,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "a",
    width: 832,
    height: 832,
    x: 96,
    y: 96,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M808.825 109.876C767.549 96 740.643 96 644.764 96H379.231c-95.878 0-122.78 0-164.056 13.876-48.802 17.837-87.462 56.497-105.299 105.294C96 256.451 96 283.353 96 379.231v265.533c0 95.879 0 122.785 13.876 164.061 17.837 48.797 56.497 87.462 105.299 105.294C256.451 928 283.353 928 379.231 928h265.533c95.879 0 122.785 0 164.061-13.881 48.797-17.832 87.462-56.497 105.294-105.294C928 767.549 928 740.643 928 644.764V379.231c0-95.878 0-122.78-13.881-164.061-17.832-48.797-56.497-87.457-105.294-105.294",
    clipRule: "evenodd",
    style: {
      fill: "#fff",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#23222F",
    d: "M96 96h832v832H96z",
    style: (_ref2 = {
      fill: "#23222f"
    }, _defineProperty(_ref2, "fill", "color(display-p3 .1357 .134 .186)"), _defineProperty(_ref2, "fillOpacity", 1), _ref2)
  }), /*#__PURE__*/React.createElement("rect", {
    width: 768,
    height: 768,
    x: 128,
    y: 128,
    fill: "url(#b)",
    rx: 160,
    style: {
      mixBlendMode: "luminosity"
    }
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#c)",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 512,
    cy: 900.615,
    fill: "#4FAAFF",
    rx: 400,
    ry: 384.615,
    style: (_ref3 = {
      fill: "#4faaff"
    }, _defineProperty(_ref3, "fill", "color(display-p3 .3098 .6667 1)"), _defineProperty(_ref3, "fillOpacity", 1), _ref3)
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#d)",
    opacity: 0.7,
    style: {
      mixBlendMode: "overlay"
    }
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 476,
    cy: 882,
    fill: "#fff",
    rx: 183,
    ry: 72,
    style: {
      fill: "#fff",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#e)",
    opacity: 0.6,
    style: {
      mixBlendMode: "luminosity"
    }
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 512,
    cy: 96,
    fill: "#B3B3B3",
    fillOpacity: 0.5,
    rx: 284,
    ry: 129,
    style: (_ref4 = {
      fill: "#b3b3b3"
    }, _defineProperty(_ref4, "fill", "color(display-p3 .7 .7 .7)"), _defineProperty(_ref4, "fillOpacity", 0.5), _ref4)
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#f)",
    opacity: 0.2,
    style: {
      mixBlendMode: "luminosity"
    }
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 512,
    cy: 96,
    fill: "#B3B3B3",
    fillOpacity: 0.5,
    rx: 542,
    ry: 246,
    style: (_ref5 = {
      fill: "#b3b3b3"
    }, _defineProperty(_ref5, "fill", "color(display-p3 .7 .7 .7)"), _defineProperty(_ref5, "fillOpacity", 0.5), _ref5)
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-burn"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    width: 768,
    height: 768,
    x: 128,
    y: 128,
    fill: "#4FAAFF",
    opacity: 0.2,
    rx: 160,
    style: (_ref6 = {
      fill: "#4faaff"
    }, _defineProperty(_ref6, "fill", "color(display-p3 .3098 .6667 1)"), _defineProperty(_ref6, "fillOpacity", 1), _ref6)
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#g)",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M725.606 331.636c5.112-3.377 11.887.525 11.531 6.642l-31.313 538.204c-.401 6.892-9.157 9.571-13.346 4.083L537.777 677.88a7.45 7.45 0 0 0-4.931-2.861L280.45 641.283c-6.82-.911-8.857-9.795-3.116-13.587z",
    clipRule: "evenodd",
    style: {
      fill: "#000",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#h)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M632.268 407.006c5.113-3.382 11.892.52 11.536 6.639l-25.833 444.694c-.401 6.896-9.163 9.573-13.35 4.079l-126.959-166.59a7.44 7.44 0 0 0-4.932-2.865l-207.193-27.736c-6.816-.912-8.854-9.79-3.118-13.584z",
    clipRule: "evenodd",
    style: {
      fill: "#000",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#i)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#4FAAFF",
    fillRule: "evenodd",
    d: "M680.944 244.828c5.112-3.381 11.892-.41 11.536 5.709l-14.605 264.65-14.969 263.809c-.656 29.379-25.476 48.962-46.315 21.639-44.91-58.881-111-159-145-180.5s-150.246-31.958-224-38.5c-20-1.774-27-33-7.753-45.474z",
    clipRule: "evenodd",
    style: (_ref7 = {
      fill: "#4faaff"
    }, _defineProperty(_ref7, "fill", "color(display-p3 .3098 .6667 1)"), _defineProperty(_ref7, "fillOpacity", 1), _ref7)
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#130D20",
    strokeOpacity: 0.6,
    strokeWidth: 1.5,
    d: "M681.358 245.454c2.341-1.549 5.036-1.627 7.083-.656 2.03.961 3.45 2.958 3.291 5.695v.002l-14.606 264.65v.001l-14.969 263.808v.012l-.001.013c-.324 14.519-6.618 26.469-15.215 31.451-4.28 2.48-9.145 3.248-14.203 1.763-5.072-1.49-10.407-5.269-15.551-12.013-11.221-14.711-23.766-32.001-36.81-50.005l-1.418-1.957c-12.603-17.397-25.64-35.391-38.36-52.302-13.197-17.544-26.062-33.931-37.76-47.282-11.683-13.335-22.249-23.695-30.848-29.133-8.609-5.444-22.351-10.151-39.195-14.26-16.864-4.115-36.914-7.646-58.191-10.708-42.554-6.123-90.074-10.374-126.948-13.645-9.57-.849-16.123-8.754-17.924-18.119-1.798-9.348 1.193-19.939 10.512-25.978l.006-.004z",
    style: (_ref8 = {
      stroke: "#130d20"
    }, _defineProperty(_ref8, "stroke", "color(display-p3 .0761 .0503 .1247)"), _defineProperty(_ref8, "strokeOpacity", 0.6), _defineProperty(_ref8, "mixBlendMode", "soft-light"), _ref8)
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#j)",
    fillOpacity: 0.75,
    fillRule: "evenodd",
    d: "M680.944 244.828c5.112-3.381 11.892-.41 11.536 5.709l-14.605 264.65-14.969 263.809c-.656 29.379-25.476 48.962-46.315 21.639-44.91-58.881-111-159-145-180.5s-150.246-31.958-224-38.5c-20-1.774-27-33-7.753-45.474z",
    clipRule: "evenodd",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("mask", {
    id: "k",
    width: 465,
    height: 571,
    x: 228,
    y: 243,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M680.944 244.828c5.112-3.381 11.892-.41 11.536 5.709l-14.605 264.65-14.969 263.809c-.656 29.379-25.476 48.962-46.315 21.639-44.91-58.881-111-159-145-180.5s-150.246-31.958-224-38.5c-20-1.774-27-33-7.753-45.474z",
    clipRule: "evenodd",
    style: {
      fill: "#fff",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#k)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M681.054 246.201c5.112-3.382 11.892.52 11.536 6.639l-30.783 529.892c-.832 14.332-19.599 19.462-27.639 7.568-40.254-59.551-117.96-170.955-148.401-190.037-30.407-19.06-165.524-30.387-237.415-35.17-14.357-.955-19.409-19.842-7.409-27.78z",
    clipRule: "evenodd",
    opacity: 0.3,
    style: {
      fill: "#000",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#l)",
    style: {
      mixBlendMode: "overlay"
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 682.5,
    cy: 833.5,
    r: 45.5,
    fill: "#fff",
    style: {
      fill: "#fff",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#m)",
    opacity: 0.9,
    style: {
      mixBlendMode: "soft-light"
    }
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 558.861,
    cy: 683.774,
    fill: "#fff",
    rx: 8,
    ry: 88.852,
    style: {
      fill: "#fff",
      fillOpacity: 1
    },
    transform: "rotate(-37 558.861 683.774)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#n)",
    opacity: 0.5,
    style: {
      mixBlendMode: "overlay"
    }
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 10.385,
    cy: 104.25,
    fill: "#fff",
    rx: 10.385,
    ry: 104.25,
    style: {
      fill: "#fff",
      fillOpacity: 1
    },
    transform: "scale(-1 1)rotate(82.5 -442.793 125.358)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "o",
    width: 459,
    height: 553,
    x: 235,
    y: 242,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#D8D8D8",
    fillRule: "evenodd",
    d: "M682.055 244.201c5.112-3.382 11.891.52 11.536 6.639l-30.783 529.892c-.833 14.332-19.6 19.462-27.639 7.568-40.255-59.551-117.96-170.956-148.402-190.037-30.407-19.06-165.524-30.387-237.415-35.17-14.356-.955-19.409-19.842-7.408-27.78z",
    clipRule: "evenodd",
    style: (_ref9 = {
      fill: "#d8d8d8"
    }, _defineProperty(_ref9, "fill", "color(display-p3 .847 .847 .847)"), _defineProperty(_ref9, "fillOpacity", 1), _ref9)
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#o)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#p)",
    fillRule: "evenodd",
    d: "m694.453 236-34.265 589.819-173.421-227.556z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#q)",
    fillRule: "evenodd",
    d: "M694.453 236 486.767 598.263 204 560.411z",
    clipRule: "evenodd"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#r)",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#s)",
    fillRule: "evenodd",
    d: "M613.558 375.123 550.73 674.92l-57.648-76.987-104.66-34.887z",
    clipRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#t)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.2,
    fillRule: "evenodd",
    d: "M682.054 244.201c5.112-3.382 11.892.52 11.536 6.639l-30.783 529.892c-.832 14.332-19.599 19.462-27.639 7.568-40.254-59.551-117.96-170.955-148.401-190.037-30.407-19.06-165.524-30.387-237.415-35.17-14.357-.955-19.409-19.842-7.409-27.78z",
    clipRule: "evenodd",
    style: {
      fill: "#fff",
      fillOpacity: 0.2,
      mixBlendMode: "soft-light"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#u)",
    strokeWidth: 1.5,
    d: "M682.468 244.826c4.597-3.04 10.693.468 10.374 5.97l-30.783 529.893c-.791 13.612-18.63 18.493-26.27 7.191-20.129-29.779-49.627-72.53-77.902-110.225-14.136-18.846-27.973-36.437-40.184-50.514-12.192-14.054-22.821-24.676-30.538-29.513-7.728-4.844-21.997-9.147-40.058-12.962-18.095-3.823-40.106-7.179-63.398-10.086-46.588-5.815-98.357-9.843-134.307-12.235-13.647-.908-18.442-18.868-7.045-26.406z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#v)",
    d: "m310.521 501.14 366.543-245.603-74.425 100.009c-27.774 37.935-77.172 60.604-128.848 74.89-54.777 15.143-132.873 80.038-163.27 70.704"
  }))), /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    opacity: 0.6,
    style: {
      mixBlendMode: "overlay"
    }
  }, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "w"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M808.825 109.876C767.549 96 740.643 96 644.764 96H379.231c-95.878 0-122.78 0-164.056 13.876-48.802 17.837-87.462 56.497-105.299 105.294C96 256.451 96 283.353 96 379.231v265.533c0 95.879 0 122.785 13.876 164.061 17.837 48.797 56.497 87.462 105.299 105.294C256.451 928 283.353 928 379.231 928h265.533c95.879 0 122.785 0 164.061-13.881 48.797-17.832 87.462-56.497 105.294-105.294C928 767.549 928 740.643 928 644.764V379.231c0-95.878 0-122.78-13.881-164.061-17.832-48.797-56.497-87.457-105.294-105.294",
    clipRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m215.175 109.876-10.197-30.332-.396.133-.393.144zM109.876 215.17l-30.055-10.986-.144.393-.133.397zm0 593.655-30.332 10.197.133.397.144.393zm105.299 105.294-10.983 30.057.39.142.393.132zm593.65 0 10.2 30.331.394-.132.39-.143zm105.294-105.294 30.056 10.984.143-.39.132-.394zm0-593.655 30.332-10.199-.133-.394-.143-.391zM819.022 79.544C771.797 63.668 739.18 64 644.764 64v64c97.342 0 118.537.332 153.865 12.208zM644.764 64H379.231v64h265.533zm-265.533 0c-94.416 0-127.028-.332-174.253 15.544l20.393 60.664C260.7 128.332 281.89 128 379.231 128zM204.189 79.82c-57.656 21.074-103.294 66.712-124.368 124.364l60.11 21.972c14.6-39.941 46.283-71.624 86.229-86.225zM79.544 204.975C63.669 252.203 64 284.815 64 379.231h64c0-97.341.332-118.532 12.208-153.865zM64 379.231v265.533h64V379.231zm0 265.533c0 94.416-.332 127.033 15.544 174.258l60.664-20.393C128.332 763.301 128 742.106 128 644.764zm15.82 175.048c21.074 57.65 66.711 103.294 124.372 124.364l21.966-60.113c-39.943-14.595-71.626-46.281-86.227-86.224zM204.976 944.45c47.225 15.882 79.84 15.55 174.255 15.55v-64c-97.342 0-118.53-.332-153.856-12.211zM379.231 960h265.533v-64H379.231zm265.533 0c94.415 0 127.034.332 174.261-15.55l-20.4-60.661C763.299 895.668 742.106 896 644.764 896zm175.045-15.825c57.654-21.069 103.297-66.712 124.366-124.366l-60.111-21.968c-14.596 39.94-46.283 71.627-86.223 86.223zm124.641-125.15C960.332 771.798 960 739.179 960 644.764h-64c0 97.342-.332 118.535-12.211 153.861zM960 644.764V379.231h-64v265.533zm0-265.533c0-94.416.332-127.029-15.549-174.26l-60.663 20.398C895.668 260.701 896 281.89 896 379.231zm-15.825-175.045c-21.07-57.655-66.713-103.292-124.363-124.365l-21.973 60.11c39.944 14.601 71.629 46.285 86.225 86.223z",
    mask: "url(#w)",
    style: {
      fill: "#fff",
      fillOpacity: 1
    }
  }))), /*#__PURE__*/React.createElement("defs", null, _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "c",
    width: 1408.99,
    height: 1378.22,
    x: -192.493,
    y: 211.507,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_28_9",
    stdDeviation: 152.247
  }))), _filter2 || (_filter2 = /*#__PURE__*/React.createElement("filter", {
    id: "d",
    width: 686,
    height: 464,
    x: 133,
    y: 650,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_28_9",
    stdDeviation: 80
  }))), _filter3 || (_filter3 = /*#__PURE__*/React.createElement("filter", {
    id: "e",
    width: 888,
    height: 578,
    x: 68,
    y: -193,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_28_9",
    stdDeviation: 80
  }))), _filter4 || (_filter4 = /*#__PURE__*/React.createElement("filter", {
    id: "f",
    width: 1444,
    height: 852,
    x: -210,
    y: -330,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_28_9",
    stdDeviation: 90
  }))), _filter5 || (_filter5 = /*#__PURE__*/React.createElement("filter", {
    id: "g",
    width: 693.882,
    height: 783.832,
    x: 158.628,
    y: 215.029,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_28_9",
    stdDeviation: 57.679
  }))), _filter6 || (_filter6 = /*#__PURE__*/React.createElement("filter", {
    id: "h",
    width: 496.38,
    height: 571.243,
    x: 203.257,
    y: 349.937,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_28_9",
    stdDeviation: 27.909
  }))), _filter7 || (_filter7 = /*#__PURE__*/React.createElement("filter", {
    id: "i",
    width: 464.007,
    height: 570.287,
    x: 228.487,
    y: 243.411,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.309804 0 0 0 0 0.666667 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    mode: "soft-light",
    result: "effect1_innerShadow_28_9"
  }))), _filter8 || (_filter8 = /*#__PURE__*/React.createElement("filter", {
    id: "l",
    width: 115,
    height: 115,
    x: 625,
    y: 776,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_28_9",
    stdDeviation: 6
  }))), _filter9 || (_filter9 = /*#__PURE__*/React.createElement("filter", {
    id: "m",
    width: 131.716,
    height: 166.252,
    x: 493.003,
    y: 600.648,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_28_9",
    stdDeviation: 6
  }))), _filter10 || (_filter10 = /*#__PURE__*/React.createElement("filter", {
    id: "n",
    width: 230.735,
    height: 58.13,
    x: 247.346,
    y: 542.839,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_28_9",
    stdDeviation: 6
  }))), _filter11 || (_filter11 = /*#__PURE__*/React.createElement("filter", {
    id: "r",
    width: 344.216,
    height: 418.877,
    x: 328.882,
    y: 315.583,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_28_9",
    stdDeviation: 29.77
  }))), _filter12 || (_filter12 = /*#__PURE__*/React.createElement("filter", {
    id: "t",
    width: 458.38,
    height: 551.963,
    x: 235.223,
    y: 242.951,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 32
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.233594 0 0 0 0 0.253455 0 0 0 0 0.308073 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    mode: "soft-light",
    result: "effect1_innerShadow_28_9"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x1: 237.5,
    x2: 666,
    y1: 537,
    y2: 780.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1A1A",
    style: (_ref10 = {
      stopColor: "#1a1a1a"
    }, _defineProperty(_ref10, "stopColor", "color(display-p3 .1 .1 .1)"), _defineProperty(_ref10, "stopOpacity", 1), _ref10)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.034,
    stopColor: "#BFBFBF",
    style: (_ref11 = {
      stopColor: "#bfbfbf"
    }, _defineProperty(_ref11, "stopColor", "color(display-p3 .75 .75 .75)"), _defineProperty(_ref11, "stopOpacity", 1), _ref11)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.079,
    stopColor: "gray",
    style: (_ref12 = {
      stopColor: "gray"
    }, _defineProperty(_ref12, "stopColor", "color(display-p3 .5 .5 .5)"), _defineProperty(_ref12, "stopOpacity", 1), _ref12)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.498,
    stopColor: "#4D4D4D",
    style: (_ref13 = {
      stopColor: "#4d4d4d"
    }, _defineProperty(_ref13, "stopColor", "color(display-p3 .3 .3 .3)"), _defineProperty(_ref13, "stopOpacity", 1), _ref13)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.504,
    stopColor: "#999",
    style: (_ref14 = {
      stopColor: "#999"
    }, _defineProperty(_ref14, "stopColor", "color(display-p3 .6 .6 .6)"), _defineProperty(_ref14, "stopOpacity", 1), _ref14)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.955,
    stopColor: "#E6E6E6",
    style: (_ref15 = {
      stopColor: "#e6e6e6"
    }, _defineProperty(_ref15, "stopColor", "color(display-p3 .9 .9 .9)"), _defineProperty(_ref15, "stopOpacity", 1), _ref15)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333",
    style: (_ref16 = {
      stopColor: "#333"
    }, _defineProperty(_ref16, "stopColor", "color(display-p3 .2 .2 .2)"), _defineProperty(_ref16, "stopOpacity", 1), _ref16)
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "p",
    x1: 694.275,
    x2: 564.032,
    y1: 236,
    y2: 696.505,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A7AEB6",
    style: (_ref17 = {
      stopColor: "#a7aeb6"
    }, _defineProperty(_ref17, "stopColor", "color(display-p3 .653 .6833 .7137)"), _defineProperty(_ref17, "stopOpacity", 1), _ref17)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A4B1BF",
    style: (_ref18 = {
      stopColor: "#a4b1bf"
    }, _defineProperty(_ref18, "stopColor", "color(display-p3 .6426 .6958 .7491)"), _defineProperty(_ref18, "stopOpacity", 1), _ref18)
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "q",
    x1: 694.276,
    x2: 342.617,
    y1: 236,
    y2: 577.426,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7FAFB",
    style: (_ref19 = {
      stopColor: "#f7fafb"
    }, _defineProperty(_ref19, "stopColor", "color(display-p3 .9672 .9814 .9828)"), _defineProperty(_ref19, "stopOpacity", 1), _ref19)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.542,
    stopColor: "#ECEEED",
    style: (_ref20 = {
      stopColor: "#eceeed"
    }, _defineProperty(_ref20, "stopColor", "color(display-p3 .9252 .9345 .9289)"), _defineProperty(_ref20, "stopOpacity", 1), _ref20)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEDFE2",
    style: (_ref21 = {
      stopColor: "#dedfe2"
    }, _defineProperty(_ref21, "stopColor", "color(display-p3 .8706 .8738 .8877)"), _defineProperty(_ref21, "stopOpacity", 1), _ref21)
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "s",
    x1: 409.595,
    x2: 610.132,
    y1: 506.325,
    y2: 595.788,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BAB8C2",
    style: (_ref22 = {
      stopColor: "#bab8c2"
    }, _defineProperty(_ref22, "stopColor", "color(display-p3 .7294 .7216 .7608)"), _defineProperty(_ref22, "stopOpacity", 1), _ref22)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5E5E7",
    style: (_ref23 = {
      stopColor: "#e5e5e7"
    }, _defineProperty(_ref23, "stopColor", "color(display-p3 .898 .898 .9059)"), _defineProperty(_ref23, "stopOpacity", 1), _ref23)
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "u",
    x1: 682,
    x2: 441,
    y1: 252,
    y2: 681,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#13111D",
    style: (_ref24 = {
      stopColor: "#13111d"
    }, _defineProperty(_ref24, "stopColor", "color(display-p3 .0753 .0684 .115)"), _defineProperty(_ref24, "stopOpacity", 1), _ref24)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#575562",
    stopOpacity: 0.21,
    style: (_ref25 = {
      stopColor: "#575562"
    }, _defineProperty(_ref25, "stopColor", "color(display-p3 .3405 .333 .3837)"), _defineProperty(_ref25, "stopOpacity", 0.21), _ref25)
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "v",
    x1: 687.763,
    x2: 367.735,
    y1: 236.465,
    y2: 506.256,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    style: {
      stopColor: "white",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.954,
    stopColor: "#fff",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "b",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(180 256 256)scale(423)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "black",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCursor);
export default __webpack_public_path__ + "static/media/cursor.aefa63a166c7e29851c345da74ecb34f.svg";
export { ForwardRef as ReactComponent };